import styled from '@emotion/styled'
import { Space } from 'antd'
import { useMemo } from 'react'
import Image from '../../components/common/Image'
import Text from '../../components/common/Text'
import Tag from '../../components/common/Tag'
import IconCoins from '../../assets/images/icons-coins.svg'
import Card from '../../components/common/Card'
import { FONT_BLACK, PRIMARY, SECONDARY } from '../../constant/colors'
import { useTranslation } from 'react-i18next'
import { hideScrollStyle, ipadPro, mobile, tablet } from '../../utils/responsive-helper'
import { useGetRecommendNews } from '../../services/digital-news/digital-news-query'
import * as paths from '../../constant/path'
import Loading from '../../components/common/Loading'
import { Link } from 'react-router-dom'

const Layout = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  margin-top: 16px;
  margin-left: 24px;

  ${tablet} {
    margin-left: 0;
    margin-bottom: 32px;
  }
`
const GreenBadge = styled.div`
  background-color: ${SECONDARY};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  align-self: center;
  margin-left: auto;
`
const CardChildrenLayout = styled(Card)`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 116px;
  border-radius: 9.9px;
  overflow: hidden;
  margin: unset;
  cursor: pointer;
  > img {
    width: 116px;
    height: 116px;
    object-fit: contain;
  }

  /* iPad pro */
  ${ipadPro} {
    max-width: 100%;
  }
  ${mobile} {
    max-width: 100%;
  }
`
const Content = styled.div`
  padding: 11px 15px;
  flex: 1;
`
const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`
const ScrollWarpper = styled.div`
  position: relative;
  flex-grow: 1;
  width: 100%;
  ${tablet} {
    min-height: ${(116 * 3).toString() + 'px'};
    margin-bottom: 30px;
  }
`
const Scroll = styled(Space)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  width: 100%;
  padding-bottom: 5px;
  ${hideScrollStyle}
  ${tablet} {
    position: relative;
  }
`

const TagStyle = styled(Tag)`
  width: 75px;
  height: 17px;
  padding: 2px 8px 0;
  border-radius: 3px;
`

const RecommendContent = styled(Text)`
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Recommend = () => {
  const { data, isLoading } = useGetRecommendNews()
  const { t } = useTranslation()

  const renderRecommendNews = useMemo(() => {
    return data?.map(({ digitalNews, isRead }) => {
      const { id: newsId, thumbnailPath, title, type } = digitalNews
      return (
        <Link key={newsId} to={paths.newsDetails({ routeParam: { newsId } })}>
          <CardChildrenLayout style={{ cursor: 'pointer' }}>
            <Image
              src={`${process.env.REACT_APP_API_HOST}${thumbnailPath}`}
              style={{ objectFit: 'cover' }}
            />
            <Content>
              <Row>
                <TagStyle label={type} fontSize={9.6} type={type} />
                <Image src={IconCoins} style={{ width: 12, height: 12, marginLeft: 8 }} />
                {isRead === false && <GreenBadge />}
              </Row>
              <RecommendContent size={14} style={{ marginTop: 8 }}>
                {title}
              </RecommendContent>
            </Content>
          </CardChildrenLayout>
        </Link>
      )
    })
  }, [data])

  return (
    <Layout>
      <Row>
        <Text size={20} type="Bold" color={FONT_BLACK}>
          {t('news.recommend')}
        </Text>
        <div style={{ flex: 1, height: 3, background: PRIMARY, marginLeft: 16 }} />
      </Row>
      <Loading loading={isLoading}>
        <ScrollWarpper>
          <Scroll direction="vertical" size={8}>
            {renderRecommendNews}
          </Scroll>
        </ScrollWarpper>
      </Loading>
    </Layout>
  )
}

export default Recommend
